export default __webpack_public_path__ + "static/media/lateral-right.9eb400d2.png";